<template src="./template.html"></template>
<script>
import moment from 'moment'
import _isNumber from 'lodash/isNumber'
import _throttle from 'lodash/throttle'
import { mapState } from 'vuex'
import Vue from 'vue'

import InventoryListMapWithDatePicker from 'components/InventoryListMapWithDatePicker'
import iframeWidgetBaseMixin from 'mixins/iframeWidgetBase'
import iframeLib from 'lib/iframe'
import IFRAME_MESSAGE_TYPES from 'shared/constants/iframeMessageTypes'
import config from 'src/config'
import dateUtils from 'utils/dateUtils'
import store from 'src/store'
import * as mutationTypes from 'store/mutationTypes'

export default {
  name: 'inventory-list-map-widget',
  mixins: [iframeWidgetBaseMixin],
  data() {
    let theme = this.$route.query.theme
    let disableInlineCheckout = this.$route.query.disableInlineCheckout === 'true'
    let disableGuestlist = this.$route.query.disableGuestlist === 'true'

    //TODO: should eventually get the venue to update their code
    //
    if (this.$route.query.client !== 'web') {
      //ignore on the Tablelist website
      if (this.$route.query.venueId === 'eb68f0f673d5349c') {
        //NOTE: hardcode Paddy's to fix their widget colors
        theme = 'theme-dark'
      }
      if (this.$route.query.venueId === '501430668171cca0') {
        //NOTE: hardcode Revere to fix their widget colors
        theme = 'theme-dark'
      }
      if (this.$route.query.venueId === '697bc6e02b1b6f29') {
        //NOTE: hardcode Venue 578 to fix their widget colors
        theme = 'theme-dark'
      }
    }

    if (this.$route.query.venueId === 'eb68f0f673d5349c') {
      //NOTE: hardcode SundayFunday since they are inside another iframe
      disableInlineCheckout = true
    }

    if (this.$route.query.venueId === '4c8e317b5591adf9') {
      //NOTE: hardcode LUXS to hide guestlist
      disableGuestlist = true
    }

    let shouldLockDate = false

    if (this.$route.query.date) {
      let date

      if (moment(this.$route.query.date, moment.ISO_8601, true).isValid()) {
        date = moment.utc(this.$route.query.date, moment.ISO_8601)
      } else {
        const dateNum = parseInt(this.$route.query.date, 10)

        if (_isNumber(dateNum)) {
          date = moment.utc(parseInt(this.$route.query.date, 10), 'x')
        } else {
          date = moment.utc(this.$route.query.date)
        }
      }

      if (date.isValid()) {
        date = dateUtils.toUTCMomentWithoutTime(date)

        this.$store.dispatch('setCurrentDate', date)

        shouldLockDate = true
      }
    }

    return {
      loading: true,
      eventId: this.$route.query.eventId,
      venueId: this.$route.query.venueId,
      shouldLockDate,
      affiliateId: this.$route.query.affiliateId,
      trackingId: this.$route.query.trackingId,
      attributionId: this.$route.query.attributionId,
      hideTickets: this.$route.query.hideTickets === 'true',
      disableInlineCheckout,
      disableGuestlist,
      client: this.$route.query.client,
      checkoutUrl: this.$route.query.checkoutUrl,
      theme,
    }
  },
  methods: {
    onScrollTop() {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.WIDGET_SCROLL_TOP,
          iframeId: this.iframeId,
        },
        {
          parent: true,
        }
      )
    },
    onIframeBlurred() {
      this.$refs.inventoryMapWithDatePicker.onIframeBlurred()
    },
    onDatepickerOpened() {
      Vue.nextTick(() => {
        this.publishDimensions({
          minHeight: 420,
        })
      })
    },
    onDatepickerClosed() {
      this.publishDimensions()
    },
    onInventorySelected(data) {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.INVENTORY_SELECTED,
          iframeId: this.iframeId,
          data,
        },
        {
          parent: true,
        }
      )
    },
    onUpdated() {
      this.publishDimensions()
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.START_CHECKOUT) {
        iframeLib.publish(
          {
            name: config.IFRAME_MESSAGE_NAME,
            type: IFRAME_MESSAGE_TYPES.CHECKOUT,
            iframeId: this.iframeId,
            data: {
              items: this.items,
              affiliateId: this.affiliateId,
              attributionId: this.attributionId,
              trackingId: this.trackingId,
              client: this.client,
            },
          },
          {
            parent: true,
          }
        )

        this.$store.dispatch('clearCheckoutCartItems')
      }
    },
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      items: (state) => state.checkout.items,
    }),
  },
  components: {
    InventoryListMapWithDatePicker,
  },
  created() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)

    this.onWindowScrolled = _throttle(
      function (options = {}) {
        if (this.$refs.inventoryMapWithDatePicker) {
          this.$refs.inventoryMapWithDatePicker.onWindowScrolled(options)
        }
      },
      1,
      {
        trailing: true,
        leading: true,
      }
    )

    this.loading = true

    const promises = [this.$store.dispatch('getVenue', this.$route.query.venueId), this.$store.dispatch('getCurrentLayoutSections', this.$route.query.venueId)]

    if (this.eventId) {
      promises.push(this.$store.dispatch('setConfigEventId', this.eventId))
    }

    if (this.attributionId) {
      promises.push(this.$store.dispatch('setConfigAttributionId', this.attributionId))
    }

    if (this.affiliateId) {
      promises.push(this.$store.dispatch('setConfigAffiliateId', this.affiliateId))
    }

    if (this.trackingId) {
      promises.push(this.$store.dispatch('setConfigTrackingId', this.trackingId))
    }

    if (this.client) {
      promises.push(this.$store.dispatch('setConfigClient', this.client))
    }

    Promise.all(promises)
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/InventoryListMap/index.vue